import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { login } from "Redux/authSlice";

export default function Middleware() {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const setToken = searchParams.get("setToken");

  const { isLoggedIn } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!isLoggedIn) {
      if (setToken) {
        dispatch(login(setToken));
        navigate("/");
      } else {
        navigate("/login");
      }
    } else if (location.pathname === "/login") {
      navigate("/");
    }
  }, [location.pathname, isLoggedIn]);

  return <Outlet />;
}
